import React from 'react';
import { H1Box } from './h1.styles';
export function H1(props) {
  const {
    boxRef,
    ...rest
  } = props;
  return React.createElement(H1Box, {
    ...rest,
    ref: boxRef
  });
}